$.fn.loadhtml = function(option){
  const opt = $.extend(true, {
    path: '/assets/source',
    ext: 'html',
    cache: false
  },option),
  dfds = []

  this.each((i,v) => {
    const ajaxopt = {
      cache: opt.cache,
      url: `${opt.path}/${v.dataset.loadHtml}.${opt.ext}`,
      type: 'GET'
    }
    window.load[v.dataset.loadHtml] = new $.Deferred
    const dfd = $.ajax(ajaxopt).done((data) => {
      v.outerHTML = data
      window.load[v.dataset.loadHtml].resolve(data)
    })
    dfds.push(dfd)
  })
  return $.when.apply($, dfds)
}